var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNewWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 6,
    viewBox: "0 0 16 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.120819 5.45005H1.24082L1.73082 2.69905L3.13082 5.45005H3.97082L4.83182 0.550049H3.71182L3.22882 3.30105L1.82182 0.550049H0.981819L0.120819 5.45005Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52727 1.62805L8.71627 0.550049H5.67127L4.81027 5.45005H7.89027L8.07927 4.37205H6.11927L6.27327 3.49705H8.02327L8.21227 2.44705H6.45527L6.60227 1.62805H8.52727Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52319 5.45005H10.7972L12.0992 2.55905L12.3932 5.45005H13.6672L15.8792 0.550049H14.6612L13.2122 3.98005L12.8692 0.550049H11.9592L10.4122 3.98005L10.1532 0.550049H9.03319L9.52319 5.45005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNewWhite);
export default __webpack_public_path__ + "static/media/ic_new_white.ec98c721100aa45895afd3907263133d.svg";
export { ForwardRef as ReactComponent };